import React from "react";
import { LichessResponse } from "../getOpeningBookMove";
import { Checkbox, Progress, Table } from "@mantine/core";
import { useExclusionsStorage } from "../ZustandState";
import cn from "classnames";

interface Props {
    openingData: LichessResponse;
    isPlayersTurn: boolean;
}

const MoveStatistics: React.FC<Props> = ({ openingData, isPlayersTurn }) => {
    const excludedMoves = useExclusionsStorage((state) => state.excludedMoves);
    const setExcludedMoves = useExclusionsStorage((state) => state.setExcludedMoves);

    const transformedMoves = openingData.moves.map((move) => {
        const total = move.white + move.black + move.draws;
        return {
            ...move,
            white: move.white || 0,
            black: move.black || 0,
            total,
            percentageWhite: Math.round(((move.white || 0) / total) * 100),
            percentageBlack: Math.round(((move.black || 0) / total) * 100),
            percentageDraws: Math.round(((move.draws || 0) / total) * 100),
            percentage: Math.round((total / (openingData.white + openingData.black + openingData.draws)) * 100),
        };
    });

    const rows = transformedMoves.map((move) => (
        <Table.Tr
            key={move.san}
            className={cn({ "hover:bg-[var(--mantine-color-blue-light)] hover:cursor-pointer": !isPlayersTurn })}
            onClick={() => {
                if (isPlayersTurn) {
                    return;
                }
                setExcludedMoves(
                    excludedMoves.includes(move.san)
                        ? excludedMoves.filter((san) => san !== move.san)
                        : [...excludedMoves, move.san]
                );
            }}
        >
            <Table.Td>
                <div className={cn({ invisible: isPlayersTurn })}>
                    <Checkbox
                        aria-label="Select row"
                        checked={!excludedMoves.includes(move.san)}
                        className="hover:cursor-pointer"
                        styles={{ input: { cursor: "pointer" } }}
                        disabled={isPlayersTurn}
                        defaultChecked
                    />
                </div>
            </Table.Td>
            <Table.Td>{move.san}</Table.Td>
            <Table.Td>{move.percentage}%</Table.Td>
            <Table.Td width={180}>
                <Progress.Root size="xl">
                    <Progress.Section value={move.percentageWhite} color="#DDD">
                        {move.percentageWhite >= 20 && (
                            <Progress.Label className="!text-black">{move.percentageWhite}%</Progress.Label>
                        )}
                    </Progress.Section>
                    <Progress.Section value={move.percentageDraws} color="#a0a0a0">
                        {move.percentageDraws >= 20 && (
                            <Progress.Label className="!text-black">{move.percentageDraws}%</Progress.Label>
                        )}
                    </Progress.Section>
                    <Progress.Section value={move.percentageBlack} color="#555">
                        {move.percentageBlack >= 20 && <Progress.Label>{move.percentageBlack}%</Progress.Label>}
                    </Progress.Section>
                </Progress.Root>
            </Table.Td>
        </Table.Tr>
    ));

    return (
        <Table>
            <Table.Thead>
                {/* <Table.Tr>
                    <Table.Th />
                    <Table.Th>Element position</Table.Th>
                    <Table.Th>Element name</Table.Th>
                    <Table.Th>Symbol</Table.Th>
                    <Table.Th>Atomic mass</Table.Th>
                </Table.Tr> */}
            </Table.Thead>
            <Table.Tbody>{rows}</Table.Tbody>
        </Table>
    );
};

export default MoveStatistics;
